import { render } from "./feature-group-create.vue?vue&type=template&id=6613360b"
import script from "./feature-group-create.vue?vue&type=script&lang=js"
export * from "./feature-group-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__